import type { TOC } from '@ember/component/template-only';
import { on } from '@ember/modifier';
import didInsert from '@ember/render-modifiers/modifiers/did-insert';

import t from 'ember-intl/helpers/t';

import Button from 'umg-ember-backend/components/ui/button';
import Form from 'umg-ember-backend/components/ui/form';
import InfoBox from 'umg-ember-backend/components/ui/info-box';
import Window from 'umg-ember-backend/components/ui/window';
import { getBem } from 'umg-ember-backend/utils/get-bem';

import type ResetVoucherController from './controller';
import styles from './styles.module.css';

const bem = getBem(styles);

interface ResetVoucherRouteSignature {
  Args: {
    controller: ResetVoucherController;
  };
}

<template>
  <Window {{didInsert @controller.setHeadData}}>
    <:title>
      {{t 'tool_reset_voucher.headline'}}
    </:title>

    <:description>
      {{t 'tool_reset_voucher.description'}}
    </:description>

    <:body>
      <Form
        @disableRegisterToBreadcrumb={{true}}
        @model={{@controller.resetVoucherSettings}}
        as |form|
      >
        <div class='o-layout'>
          <div class='o-layout__item u-1/1 u-1/2@tablet'>
            <form.fieldset
              @titleKey='settings'
              data-test-reset-voucher-form
              data-test-reset-voucher-settings
              as |fieldset|
            >
              <fieldset.field
                @property='code'
                autocomplete='off'
                data-test-reset-voucher-code
                required
              />

              {{#if @controller.formattedResult}}
                <section
                  aria-label={{t 'tool_reset_voucher.result'}}
                  aria-live='polite'
                  data-test-reset-voucher-result
                >
                  <InfoBox @type='warning'>
                    {{! Keep pre/code tags and content adjacent: template whitespace is rendered. }}
                    <pre class={{bem 'output'}}><code
                        data-test-reset-voucher-json
                      >{{~@controller.formattedResult~}}</code></pre>
                  </InfoBox>
                </section>
              {{/if}}

              <Button
                @disabled={{@controller.isSubmitDisabled}}
                @label={{t 'tool_reset_voucher.submit'}}
                @type='button'
                data-test-reset-voucher-submit
                {{on 'click' @controller.submit}}
              />
            </form.fieldset>
          </div>
        </div>
      </Form>
    </:body>
  </Window>
</template> satisfies TOC<ResetVoucherRouteSignature>;
